import { render } from "./SegmentFilterBody.vue?vue&type=template&id=1f288ad4"
import script from "./SegmentFilterBody.vue?vue&type=script&lang=js"
export * from "./SegmentFilterBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__